module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/cover-3-9ace2cb975da3c09e6894c362dde91ed.webp";